import { GzAntimalwareVendorsExclusionsListsWebComponent } from './component/GzAntimalwareVendorsExclusionsListsWebComponent';

export { GzAntimalwareVendorsExclusionsListsWebComponent };
